import React, { Component } from 'react'
import moment from 'moment'
import AlertBanner from 'components/alerts/alert-banner'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import Loader from 'components/loader/loader'

import {
	dashboardQuery,
} from 'state/actions'

import DashboardCalendarEventGroup from './dashboard-calendar-eventgroup'
import DropdownMenu from 'components/dropdown-menu/dropdown-menu'

import BigCalendar from 'components/big-calendar/big-calendar'

import {
	formatTaskDate,
	getPrimaryColumnValue,
	formatByTimeZone
} from 'utils'

import copy from 'fast-copy'

import { MainContext } from 'context'

class DashboardCalendar extends Component {
	state = {
		selectedDate: new Date(),
		selectedUserId: this.props.userData.id
	}

	componentWillUpdate = nextProps => {
		const hasEventQuery = this.props.queries && this.props.queries.event
		const willHaveEventQuery = nextProps.queries && nextProps.queries.event

		if (!hasEventQuery && willHaveEventQuery) {
			const {
				allEvents
			} = nextProps

			const eventId = parseInt(nextProps.queries.event)

			const event = allEvents[eventId]

			if (event) {
				this.setState({
					selectedDate: formatByTimeZone(event.date, null, true).toDate(),
				})
			}
		}
	}

	handleDateChange = day => {
		if (!moment(this.state.selectedDate).isSame(moment(day))) {
			this.setState({
				selectedDate: day
			})
		}
	}

	changeMonth = direction => {
		const newMonth = moment(this.state.selectedDate)

		switch (direction) {
			case 'next':
				newMonth.add(1, 'month')
				break
			case 'prev':
				newMonth.subtract(1, 'month')
				break
		}

		this.setState({
			selectedDate: newMonth.toDate()
		})
	}

	getApplicableEntities = (type, _formattedDate) => {
		const {
			accountData,
			allTasks = {},
			allMilestones,
			allProjects,
			allEvents = {}
		} = this.props

		const { selectedUserId } = this.state

		const formattedDate = type === 'day' ? _formattedDate : this.state.selectedDate

		const dateMoment = moment(formattedDate).startOf('day')

		const applicableTasks = []
		const tasksContinuing = []
		const tasksStarting = []

		Object.keys(allTasks).forEach(taskId => {
			const task = allTasks[taskId]

			const milestone = allMilestones[task.milestone_id]

			if (!milestone) {
				return null
			}

			const project = allProjects[milestone.project_id]

			if (!project) {
				return null
			}

			const taskUsers = getPrimaryColumnValue('people', task, project)
			let taskDates = copy(getPrimaryColumnValue('date', task, project))

			if(taskDates.end){
				taskDates.end = formatByTimeZone(taskDates.end, 'YYYY-MM-DD')
			}

			if(taskDates.start){
				taskDates.start = formatByTimeZone(taskDates.start, 'YYYY-MM-DD')
			}

			if (!taskDates || !taskDates.end || !taskUsers.includes(selectedUserId)) {
				return false
			}

			let isRecurred = false 

			let shouldPush = false

			if (type === 'day') {
				if (task.is_recurring) {
					const {
						recurring_anchor_date,
						recurring_incrementer,
						recurring_unit
					} = task

					const recurringAnchorMoment = formatByTimeZone(recurring_anchor_date, null, true)

					let recurringUnitStr = 'days'

					switch (recurring_unit) {
						case 2:
							recurringUnitStr = 'weeks'
							break
						case 3:
							recurringUnitStr = 'months'
							break
					}

					// if it starts next month, ignore
					if (recurringAnchorMoment.isBefore(dateMoment.startOf('day'))) {
						let hasGottenPastToday = false

						const originalTaskDates = copy(taskDates)

						while (!hasGottenPastToday) {
							recurringAnchorMoment.add(parseInt(recurring_incrementer), recurringUnitStr)

							if (!recurringAnchorMoment.isAfter(dateMoment.startOf('day'))) {
								isRecurred = true
								const datesDelta = recurringAnchorMoment.diff(formatByTimeZone(recurring_anchor_date, null, true), 'days')

								if (taskDates.start) {
									taskDates.start = moment(originalTaskDates.start).add(datesDelta, 'days').format('YYYY-MM-DD')
								}

								taskDates.end = moment(originalTaskDates.end).add(datesDelta, 'days').format('YYYY-MM-DD')
							} else {
								hasGottenPastToday = true
							}
						}
					}
				}

				shouldPush = moment(taskDates.end).isSame(moment(formattedDate), 'day')

				const startMoment = moment(taskDates.start).startOf('day')
				const endMoment = moment(taskDates.end).startOf('day')

				if (taskDates.start) {
					if (startMoment.isBefore(dateMoment) && endMoment.isAfter(dateMoment)) {
						tasksContinuing.push({
							...task,
							dates: taskDates,
							isRecurred
						})
					} else if (startMoment.isSame(dateMoment, 'day')) {
						tasksStarting.push({
							...task,
							dates: taskDates,
							isRecurred
						})
					}
				}
			} else {
				const endMoment = moment(taskDates.end)

				shouldPush = endMoment.isAfter(dateMoment.startOf('month')) && endMoment.isBefore(dateMoment.endOf('month'))

				if (task.is_recurring) {
					const {
						recurring_anchor_date,
						recurring_incrementer,
						recurring_unit
					} = task

					const recurringAnchorMoment = moment(recurring_anchor_date)

					let recurringUnitStr = 'days'

					switch (recurring_unit) {
						case 2:
							recurringUnitStr = 'weeks'
							break
						case 3:
							recurringUnitStr = 'months'
							break
					}

					// if it starts next month, ignore
					if (recurringAnchorMoment.isBefore(dateMoment.endOf('month'))) {
						let hasGottenPastThisMonth = false

						while (!hasGottenPastThisMonth) {
							recurringAnchorMoment.add(parseInt(recurring_incrementer), recurringUnitStr)

							if (recurringAnchorMoment.isBefore(dateMoment.endOf('month'))) {
								isRecurred = true
								const datesDelta = recurringAnchorMoment.diff(moment(recurring_anchor_date), 'days')
								const newDates = copy(taskDates)

								if (newDates.start) {
									newDates.start = moment(newDates.start).add(datesDelta, 'days').format('YYYY-MM-DD')
								}

								newDates.end = moment(newDates.end).add(datesDelta, 'days').format('YYYY-MM-DD')

								applicableTasks.push({
									...task,
									name: `${task.name} (Recurred)`,
									dates: newDates,
									isRecurred
								})
							} else {
								hasGottenPastThisMonth = true
							}
						}
					}
				}
			}

			if (shouldPush) {
				applicableTasks.push({
					...task,
					dates: taskDates,
					isRecurred
				})
			}
		})

		const applicableEvents = []

		Object.keys(allEvents).forEach(eventId => {
			const event = allEvents[eventId]

			if (accountData.id !== event.account_id) {
				return
			}

			let shouldPush = false

			const eventDate = formatByTimeZone(event.date, null, true)

			if (type === 'day') {
				shouldPush = eventDate.isSame(moment(formattedDate, null, true), 'day')
			} else {
				shouldPush = eventDate.isAfter(dateMoment.startOf('month')) && eventDate.isBefore(dateMoment.endOf('month'))
			}

			if (shouldPush) {
				applicableEvents.push(event)
			}
		})

		return {
			tasks: applicableTasks,
			tasksContinuing,
			tasksStarting,
			events: applicableEvents
		}
	}

	getDayContents = _ => {
		const {
			selectedDate
		} = this.state

		const formattedDate = formatTaskDate(selectedDate)

		const {
			allProjects,
			allMilestones,
			allFolders,
			allEvents,
			allUsers,
			allTeams,
			accountData,
			userData,
			match,
			openModal,
		} = this.props

		if (!selectedDate) {
			return null
		}

		const dayData = this.getApplicableEntities('day', formattedDate)

		if (!dayData.tasks.length && !dayData.events.length && !dayData.tasksContinuing.length && !dayData.tasksStarting.length) {
			return null
		}

		const itemTypes = ['tasksStarting', 'tasksContinuing', 'tasks', 'events']

		return (
			<div className="calendar-right-contents">
				{ itemTypes.map(itemType => {
					let items = dayData[itemType]

					return (
						<DashboardCalendarEventGroup
							type={itemType}
							items={items}
							allProjects={allProjects}
							allMilestones={allMilestones}
							allFolders={allFolders}
							allEvents={allEvents}
							allUsers={allUsers}
							allTeams={allTeams}
							accountData={accountData}
							key={itemType + formattedDate}
							match={match}
							openModal={openModal}
							userData={userData}
						/>
					)
				})}
			</div>
		)
	}

	addEvent = _ => {
		const {
			selectedDate
		} = this.state

		this.props.openModal('create', 'event', selectedDate ? {
			date: selectedDate
		} : null)
	}

	getSelectables = type => {
		const {
			accountData,
			allTeams,
			allUsers
		} = this.props

		const response = []

		if (type === 'people') {
			accountData.users.forEach(userId => {
				if (accountData.guestIds.indexOf(userId) == -1) {
					const user = allUsers[userId]

					if (user) {
						response.push(user)
					}
				}
			})
		} else {
			accountData.teams.forEach(teamId => {
				const team = allTeams[teamId]

				if (team) {
					response.push(team)
				}
			})
		}

		return response
	}

	handleChangeUser = userId => {
		this.setState({
			isLoading: true,
			selectedUserId: userId
		})

		this.props.dashboardQuery(userId, 'person', _ => {
			this.setState({
				isLoading: false
			})
		})
	}

	render() {
		const {
			selectedDate,
			selectedUserId,
			isLoading
		} = this.state

		const {
			showUserselector,
			isFocused
		} = this.props

		let className = `widget box dashboard-calendar ${isFocused ? 'focused' : ''}`

		const dayContents = this.getDayContents()

		const eventsThisMonth = this.getApplicableEntities('month')

		return (
			<div className={className}>
				<h3>
					{moment(selectedDate).format('MMMM Y')}
					<button
						onClick={_ => { this.changeMonth('next') }}
					>
						<Icon name="angle-right" />
					</button>
					<button
						onClick={_ => { this.changeMonth('prev') }}
					>
						<Icon name="angle-left" />
					</button>
					<button onClick={this.addEvent}>
						<em>+</em>
					</button>
					{showUserselector &&
						<div className={`folder-selector-dropdown-container visible`}>
							<DropdownMenu
								isObjects={true}
								selectablePeople={this.getSelectables('people')}
								hasImage={true}
								selectedItemId={selectedUserId}
								selectedItemType={'person'}
								handleChange={this.handleChangeUser}
								parentType="people"
							/>
						</div>
					}
				</h3>
				<div>
					<div className={`calendar-left ${isLoading ? 'loading' : ''}`}>
						<Loader visible={true} />
						<BigCalendar
							date={this.state.selectedDate}
							onDateChange={this.handleDateChange}
							eventsThisMonth={eventsThisMonth}
						/>
					</div>
					<div className="calendar-right">
						{dayContents ?
							dayContents
							:
							this.state.selectedDate ?
								<AlertBanner
									low={true}
									title="Nothing to see here."
									body="We've got no events on this date." />
								: null
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		allEvents: state.account.entities.events,
		allUsers: state.account.entities.users,
		allTeams: state.account.entities.teams
	}
}

export default connect(mapStateToProps, {
	dashboardQuery,
})(DashboardCalendar)

DashboardCalendar.contextType = MainContext


// WEBPACK FOOTER //
// ./src/sections/dashboard/dashboard-calendar.jsx